/**
 * The ONE display rule for a lead's phone: `+91 9876543210`.
 *
 * `Leads.phone` holds the NATIONAL number and `Leads.phoneCountryCode` the
 * `+<calling code>` split off by the server's phone parser; every list / grid /
 * board card and the drawer render them together (user, 2026-09-08: "if the
 * phone number is shown, show the country code also"). A phone that already
 * carries its own `+` (legacy rows written before the split) is shown as-is.
 *
 * A row WITHOUT a country code is shown exactly as stored. Those are the
 * numbers the server could never parse (e.g. a UAE mobile saved as
 * "0523278916"); prefixing the default "+91" printed a number that was never
 * theirs ("+91 0523278916"). Owner, 2026-10-04: show the stored number.
 */
export function formatLeadPhone(
  phone: string | number | null | undefined,
  countryCode?: string | null,
): string {
  if (phone == null) return "";
  const national = String(phone).trim();
  if (!national) return "";
  if (national.startsWith("+")) return national;
  const raw = (countryCode ?? "").toString().trim();
  if (!raw) return national;
  const code = raw.startsWith("+") ? raw : `+${raw}`;
  return `${code} ${national}`;
}
